import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AttendanceService } from '../../attendance.service';
import { finalize } from 'rxjs';
import { SnackbarService } from '../../../services/snackbar.service';
import { SnackbarAlertStatus } from '../../../utils';

@Component({
  selector: 'app-attendance-report-modal',
  standalone: false,
  templateUrl: './attendance-report-modal.component.html',
  styleUrls: ['./attendance-report-modal.component.scss'],
})
export class AttendanceReportModalComponent {
  form: FormGroup;
  isLoading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private attendanceService: AttendanceService,
    private snackbarService: SnackbarService
  ) {
    this.form = new FormGroup({
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl('', Validators.required),
    });
  }

  onSubmit() {
    if (this.form.invalid) return;

    this.isLoading = true;
    const { startDate, endDate } = this.form.value;

    this.attendanceService
      .downloadReport({ start_date: startDate, end_date: endDate })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (response: any) => {
          if (response?.report_url) {
            const a = document.createElement('a');
            a.href = response.report_url;
            // a.target = '_blank';
            // a.download = `attendance_report_${startDate}_to_${endDate}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            this.activeModal.close();
            this.snackbarService.show(
              response.message || 'Report downloaded successfully',
              SnackbarAlertStatus.SUCCESS
            );
          } else {
            this.snackbarService.show('Report URL not found in response', SnackbarAlertStatus.ERROR);
          }
        },
        error: err => {
          console.error('Download failed', err);
          this.snackbarService.show(err.error?.message || 'Failed to generate report', SnackbarAlertStatus.ERROR);
        },
      });
  }
}
